import { all, details } from 'pages/reservationActions'

export default [
  { path: '/reservation-actions', name: 'reservationActions.all', component: all
    , meta:{permits:['reservationAction_list']}},
  { path: '/reservation-actions/:id', name: 'reservationActions.details', component: details
    , meta:{permits:['reservationAction_list']}},
]
